import { IonGrid, IonRow, IonCol, useIonRouter, IonImg, IonList, IonRadioGroup, IonListHeader, IonRadio, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import { Storage } from '@capacitor/storage';
import NServer from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import { LANGUAGE, GetStr, GetLangStr, LoadLanguage, SaveLanguage, GetLanguage } from "../language/Language";

import './Main.css'; 

const ChangeLang : React.FC = () => {

    const [ selected, setSelected ] = useState(GetLanguage());

    //	Initializing our router
	const router = useIonRouter();

    // change the selection
    const changeLanguage = (val : string) : void => {
        setSelected(val); 
    };

    // submit language change
    const submit = async () => {
        // read credential
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            p1 : "lang",
            p2 : selected
        }

        var server = new NServer();
        await server.sendForm("change_info", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            SaveLanguage(selected);
            router.push("/settings", "back", "pop");
            window.location.reload();
        }
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/profile" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonCard className="ion-padding flat-card">
                                <IonList>
                                    <IonRadioGroup value={selected} onIonChange={e => changeLanguage(e.detail.value)}>
                                        <IonListHeader>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_LANG_TITLE, selected) }</IonLabel>
                                        </IonListHeader>
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="en" />
                                            <IonImg slot="start" src="assets/img/flag_us.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_ENGLISH_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="mand" />
                                            <IonImg slot="start" src="assets/img/flag_mand.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_MANDRIAN_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                        { /* DEL
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="kch" />
                                            <IonImg slot="start" src="assets/img/flag_kch.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_KACHIN_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="sha" />
                                            <IonImg slot="start" src="assets/img/flag_sha.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_SHAN_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="chin" />
                                            <IonImg slot="start" src="assets/img/flag_chin.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_CHIN_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                        */ }
                                        <IonItem lines="none">
                                            <IonRadio slot="start" value="mmun" />
                                            <IonImg slot="start" src="assets/img/flag_mm.jpg"></IonImg>
                                            <IonLabel>{ GetLangStr(LANGUAGE.TXT_MMUN_LANGUAGE, selected) }</IonLabel>
                                        </IonItem>
                                    </IonRadioGroup>
                                </IonList>
                                <IonButton className="ion-margin-top main-but" color="primary" expand="block" onClick={submit}>{ GetLangStr(LANGUAGE.TXT_CHANGE_LANG, selected) }</IonButton>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default ChangeLang;